import React from "react";
import TextInfo from "@gc-npm/components.text";
import Glyph from "@gc-npm/components.icon-glyph";
import Button from "@gc-npm/components.button";
import dynamic from "next/dynamic";
import getColor from "@gc-npm/utils.enums.colors";

const CustomLink = dynamic(() =>
  import("@gc-npm/components.custom-link")
);

const Card = (props) => {
  const index = props.index;
  const taggingInfo = props.taggingInfo;
  const isWebView = process.env.NEXT_PUBLIC_WEB_VIEW === "true";

  return (
    <>
      <div className="roaming-card">
        <div className="roaming-content-container">
          <div>
            <div className="roaming-card-text">
              {props["Glyph-1"] && (
                <Glyph
                  {...props["Glyph-1"]}
                  dataCy={`MainCharacteristic-${index} Glyph`}
                />
              )}
              {props["Text-1"] && props["Text-1"].text && (
                <TextInfo
                  {...props["Text-1"]}
                  cyData={`RoamingCard-${index} Title`}
                />
              )}
            </div>
            <div className="roaming-card-desc">
              {props["Desc-1"] &&
                Array.isArray(props["Desc-1"]) &&
                props["Desc-1"].length &&
                props["Desc-1"].map((desc, index) => (
                  <div className="roaming-card-desc-item" key={index}>
                    {desc?.title && desc?.title.text && (
                      <TextInfo
                        {...desc?.title}
                        cyData={`RoamingCard-${index} Title`}
                      />
                    )}
                    {desc?.subTitle && desc?.subTitle.text && (
                      <TextInfo
                        {...desc?.subTitle}
                        cyData={`RoamingCard-${index} Title`}
                      />
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .roaming-card {
          border-radius: 16px;
          border: 1px solid ${getColor("GREY2")};
          opacity: 1;
          box-sizing: border-box;
          display: flex;
          flex-flow: column nowrap;

          min-height: 231px;
          overflow: hidden;
          position: relative;

          // :global(.overContent){
          //   z-index: 1;
          // }
          // &:hover {
          //   cursor: pointer;
          //   border: 1px solid ${getColor("GREY3")};
          // }

          @media screen and (max-width: 768px) {
            width: 100%;
            min-width: 269px;
            min-height: 205px;
          }

          .roaming-content-container {
            padding: 0 2rem;
            flex: 1;
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-between;
            @media screen and (max-width: 768px) {
              padding: 0 1rem;
            }

            .roaming-card-text {
              margin-bottom: 0.5rem;
              margin-top: 1rem;
              min-height: 36px;
              display: flex;
              flex-direction: row;
              :global(.text) {
                margin-left: 0.5rem;
              }
              @media screen and (max-width: 768px) {
                min-height: 30px;
                :global(.text) {
                  margin-left: 0.5rem;
                }
              }
            }

            .roaming-card-desc {
              flex-wrap: wrap;

              margin-bottom: 0.5rem;
              margin-left: 2rem;
              :global(.text) {
                line-height: 1.5rem;
                @media screen and (max-width: 768px) {
                  line-height: 20px;
                }
              }

              @media screen and (max-width: 768px) {
                width: 90%;
              }
              .roaming-card-desc-item {
                margin-bottom: 0.5rem;
              }
            }
          }
        }
      `}</style>
    </>
  );
};

export default Card;
